export default function translate(i18n, propriete) {
  if (propriete.startsWith('commissionsVendeur')) {
    const prefixI18n = 'catalogue.validation.regleCommission.';
    if (propriete.endsWith('CalculAvance')) return i18n.t(`${prefixI18n}calculAvance`);
    if (propriete.endsWith('DateDebut')) return i18n.t(`${prefixI18n}dateDebut`);
    if (propriete.endsWith('DateReference')) return i18n.t(`${prefixI18n}dateReference`);
    if (propriete.endsWith('ASignature')) return i18n.t(`${prefixI18n}aSignature`);
    if (propriete.endsWith('AEncaissement')) return i18n.t(`${prefixI18n}aEncaissement`);
    if (propriete.endsWith('PasseParMandataire')) return i18n.t(`${prefixI18n}passeParMandataire`);
    if (propriete.endsWith('ASignatureNvClient')) return i18n.t(`${prefixI18n}aSignatureNvClient`);
    if (propriete.endsWith('AEncaissementNvClient')) return i18n.t(`${prefixI18n}aEncaissementNvClient`);
    if (propriete.endsWith('CommercialId')) return i18n.t(`${prefixI18n}commercial`);
  }
  return propriete;
}
